const t = "Janela modal", e = "Fechar", l = {
  title: t,
  close: e
};
export {
  e as close,
  l as default,
  t as title
};
